module.exports = __webpack_public_path__ + "img/dianchi-80.c4fe2405.png";